import { request } from '@/utils/request'

// 考生列表
export const examList = data => {
  return request({
    method: 'POST',
    url: '/api/ksgl/manageStudent/manageStudent',
    data
  })
}

// 添加考生
export const createStudent = data => {
  return request({
    method: 'POST',
    url: '/api/ksgl/managestudent/createStudent',
    data
  })
}

// 获取科室列表
export const getSectionList = data => {
  return request({
    method: 'POST',
    url: '/api/ksgl/managestudent/getSectionInfo',
    data
  })
}

// 获取职称列表
export const getPTitleList = data => {
  return request({
    method: 'POST',
    url: '/api/ksgl/manageStudent/getPTitleEnum',
    data
  })
}

// 获取职位列表
export const getPositionList = data => {
  return request({
    method: 'POST',
    url: '/api/ksgl/manageStudent/getPosition',
    data
  })
}

// 导出考生列表
export const exportStudentExcel = data => {
  return request({
    method: 'POST',
    url: '/api/ksgl/manageStudent/exportStudentExcel',
    responseType: "blob",
    data
  })
}

// 批量导入考生
export const importExcel = data => {
  return request({
    method: 'POST',
    url: '/api/user/ImportExcel/ImportExcel',
    headers: { "Content-Type": "multipart/form-data" },
    data
  })
}

// 删除账号
export const deleteAccount = data => {
  return request({
    method: 'POST',
    url: '/api/ksgl/manageStudent/deleteStudent',
    data
  })
}

// 批量删除
export const deleteManyStudent = data => {
  return request({
    method: 'POST',
    url: '/api/ksgl/manageStudent/deleteManyStudent',
    data
  })
}
// 批量重置考试密码
export const updateMany = data => {
  return request({
    method: 'POST',
    url: '/api/ksgl/manageStudent/updateManyStudentPassword',
    data
  })
}
// 条件查询考生列表
export const seekStudent = data => {
  return request({
    method: 'POST',
    url: '/api/ksgl/manageStudent/seekStudent',
    data
  })
}

// 考试详情
export const studentDetail = data => {
  return request({
    method: 'POST',
    url: '/api/ksgl/manageStudent/studentDetail',
    data
  })
}

// 重置密码
export const resetPassword = data => {
  return request({
    method: 'POST',
    url: '/api/ksgl/manageStudent2/resetPassword',
    data
  })
}

// 考生注册流程
export const getHosCode = data => {
  return request({
    method: 'POST',
    url: '/api/ksgl/examineStudent/getHosCode',
    data
  })
}

// 确定修改考生信息
export const modifyStudentInfo = data => {
  return request({
    method: 'POST',
    url: '/api/ksgl/manageStudent/modifyStudentInfo',
    data
  })
}

// 查看答题情况题目列表
export const studentExamTest = data => {
  return request({
    method: 'POST',
    url: '/api/ksgl/examManager/studentExamTest',
    data
  })
}

// 查看试卷详情统计数据
export const studentExamInfo = data => {
  return request({
    method: 'POST',
    url: '/api/ksgl/examManager/studentExamInfo',
    data
  })
}

// 重新考试按钮
export const clearExamHistory = data => {
  return request({
    method: 'POST',
    url: '/api/ksgl/examManager/clearExamHistory',
    data
  })
}

// 用户状态关闭
export const closeStudent = data => {
  return request({
    method: 'POST',
    url: '/api/ksgl/manageStudent/closeStudent',
    data
  })
}

// 用户状态开启
export const openStudent = data => {
  return request({
    method: 'POST',
    url: '/api/ksgl/manageStudent/openStudent',
    data
  })
}

// 批量导出成绩
export const exportScoreExcel = data => {
  return request({
    method: 'POST',
    url: '/api/ksgl/manageStudent/exportExcel',
    responseType: "blob",
    data
  })
}

// ===============================  考生组  =======================================

// 查询考生组列表
export const groupList = data => {
  return request({
    method: 'POST',
    url: '/api/ksgl/groupManage/groupList',
    data
  })
}

// 分组成员管理列表
export const groupStudentList = data => {
  return request({
    method: 'POST',
    url: '/api/ksgl/groupManage/groupStudentList',
    data
  })
}

// 添加组
export const groupAdd = data => {
  return request({
    method: 'POST',
    url: '/api/ksgl/groupManage/groupAdd',
    data
  })
}

// 删除组
export const groupDelete = data => {
  return request({
    method: 'POST',
    url: '/api/ksgl/groupManage/groupDelete',
    data
  })
}

// 批量删除组
export const groupDeleteBatch = data => {
  return request({
    method: 'POST',
    url: '/api/ksgl/groupManage/groupDeleteBatch',
    data
  })
}

// 移出该组
export const deleteStudent = data => {
  return request({
    method: 'POST',
    url: '/api/ksgl/groupManage/deleteStudent',
    data
  })
}

// 修改组
export const groupUpdate = data => {
  return request({
    method: 'POST',
    url: '/api/ksgl/groupManage/groupUpdate',
    data
  })
}

// 确定添加考生进组
export const SaveAddGroupStudent = data => {
  return request({
    method: 'POST',
    url: '/api/ksgl/groupManage/SaveAddGroupStudent',
    data
  })
}

// 添加考生列表
export const getStudentList = data => {
  return request({
    method: 'POST',
    url: '/api/ksgl/manageStudent/getStudentList',
    data
  })
}


// ======================================================== 审核考生 ===============================================

// 已审核修改考生查询信息
export const selectRedayStudent = data => {
  return request({
    method: 'POST',
    url: '/api/ksgl/examineStudent/selectRedayStudent',
    data
  })
}

// 已审核考生列表
export const examineReadyStudentList = data => {
  return request({
    method: 'POST',
    url: '/api/ksgl/examineStudent/examineReadyStudentList',
    data
  })
}

// 已审核考生确定修改
export const updateRedayStudent = data => {
  return request({
    method: 'POST',
    url: '/api/ksgl/examineStudent/updateRedayStudent',
    data
  })
}

// 待审核修改考生查询信息
export const selectStudent = data => {
  return request({
    method: 'POST',
    url: '/api/ksgl/examineStudent/selectStudent',
    data
  })
}

// 待审核考生列表
export const examineStudentList = data => {
  return request({
    method: 'POST',
    url: '/api/ksgl/examineStudent/examineStudentList',
    data
  })
}

// 待审核考生审核通过不通过
export const examineStudent = data => {
  return request({
    method: 'POST',
    url: '/api/ksgl/examineStudent/examineStudent',
    data
  })
}

// 待审核考生确定修改
export const updateStudent = data => {
  return request({
    method: 'POST',
    url: '/api/ksgl/examineStudent/updateStudent',
    data
  })
}
// 是否开启考生组二维码
export const groupUpdateScan = data => {
  return request({
    method: 'POST',
    url: '/api/ksgl/groupManage/groupUpdateScan',
    data
  })
}
// 获取职位
export const getPositionEnum = data => {
  return request({
    method: 'POST',
    url: '/api/ksgl/manageStudent/getPositionEnum',
    data
  })
}
// 难易度组卷 ===》批改试卷查看考生试卷
export const getPaperTest = data => {
  return request({
    method: 'POST',
    url: '/api/paperManage_difflevel/getExam/studentExamTest/getPaperTest',
    data
  })
}